import { FormControl, Grid, InputAdornment, InputLabel, OutlinedInput } from '@mui/material'
import React from 'react'

function RiskPerTradeField({ analyze, updateSetting }: { analyze: any; updateSetting: any }) {
  return (
    <Grid item xs={12} sm={6}>
      <FormControl fullWidth variant="outlined">
        <InputLabel htmlFor="outlined-adornment-riskPerTrade">Risk per trade</InputLabel>
        <OutlinedInput
          id="outlined-adornment-riskPerTrade"
          name="analyzeTrades.riskPerTrade"
          type="number"
          value={analyze.riskPerTrade !== undefined ? (analyze.riskPerTrade * 100).toFixed(2) : ''}
          onChange={(e) => {
            // No "unlimited" state, so an empty box is a transient edit: keep the last value.
            const parsed = parseFloat(e.target.value)
            if (Number.isNaN(parsed)) return
            updateSetting('analyzeTrades.riskPerTrade', parsed / 100)
          }}
          inputProps={{ step: 0.1, min: 0.1 }}
          startAdornment={<InputAdornment position="start">%</InputAdornment>}
          label="Risk per trade"
        />
      </FormControl>
    </Grid>
  )
}

export default RiskPerTradeField
